import { ALL_ORDERS } from "@/components/pii-backfill/backfill-settings";
import { subMonths } from "date-fns";
import type { BackfillShop } from "./pii-backfill-shop-row";
import type { ShopBackfillSummary } from "./pii-backfill-summary";

export const ALL_STATUSES = "all";
export const SHOW_COVERED = "show";

export type BackfillFilters = {
  search: string;
  status: string;
  /** Hides shops already done over this order window, or SHOW_COVERED. */
  hideCovered: string;
  /** Upper bound on the shop's order count; empty keeps every shop. */
  maxOrders: string;
};

export const DEFAULT_FILTERS: BackfillFilters = {
  search: "",
  status: ALL_STATUSES,
  hideCovered: SHOW_COVERED,
  maxOrders: "",
};

export type BackfillRow = { shop: BackfillShop; summary: ShopBackfillSummary };

/**
 * A finished shop covers a window when its oldest order reaches back that far.
 * A run over every order (no `ordersSince`) covers any window.
 */
const isCovered = (
  summary: ShopBackfillSummary,
  orderWindow: string,
  now: Date,
): boolean => {
  if (summary.status !== "done") return false;
  if (summary.ordersSince === null) return true;
  if (orderWindow === ALL_ORDERS) return false;
  const cutoff = subMonths(now, Number(orderWindow)).getTime();
  return summary.ordersSince <= cutoff;
};

export const matchesFilters = (
  { shop, summary }: BackfillRow,
  filters: BackfillFilters,
  now: Date,
): boolean =>
  shop.name.toLowerCase().includes(filters.search.toLowerCase()) &&
  (filters.status === ALL_STATUSES || summary.status === filters.status) &&
  (filters.hideCovered === SHOW_COVERED ||
    !isCovered(summary, filters.hideCovered, now)) &&
  (filters.maxOrders === "" || shop.totalOrders <= Number(filters.maxOrders));
